import * as geolib from 'geolib';
import {StationDTO} from '../../dtos/StationDTO';

type Position = {latitude: number; longitude: number} | null | undefined;

interface StationCoords {
  id: string;
  latitude: number;
  longitude: number;
}

export function computeNearStation(
  stations: StationDTO[],
  pos: Position,
): StationDTO | undefined {
  if (!pos || stations.length === 0) return undefined;

  const userCoords = {latitude: pos.latitude, longitude: pos.longitude};

  const coords: StationCoords[] = stations.map(s => ({
    id: s.id,
    latitude: s.lat,
    longitude: s.lng,
  }));

  const nearest = geolib.findNearest(userCoords, coords) as StationCoords;

  const station = stations.find(s => s.id === nearest.id);
  if (!station) return undefined;

  const distanceKm = geolib
    .convertDistance(
      geolib.getDistance(userCoords, {
        latitude: station.lat,
        longitude: station.lng,
      }),
      'km',
    )
    .toFixed(1);

  return {...station, distance: distanceKm};
}
